const DEFAULT_RIGHT_ICON = 'icon_chevron_down';
export { DEFAULT_RIGHT_ICON };
//# sourceMappingURL=input-dropdown.constants.js.map